"use strict";
/**
 * 統一權限檢查工具函數
 * 用於檢查用戶是否有存取特定系統的權限和操作權限
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdmin = exports.canDeleteItem = exports.canDelete = exports.canEdit = exports.checkSystemAccess = exports.hasSystemAccess = void 0;
const types_1 = require("@redpanda/types");
/**
 * 檢查用戶是否有存取指定系統的權限
 * @param systemName 系統名稱 (如 'CRM', 'ACCOUNTING')
 * @param user 用戶資料
 * @returns 是否有存取權限
 */
const hasSystemAccess = (systemName, user) => {
    if (!user) {
        return false;
    }
    // SUPER_ADMIN 可以存取所有系統
    if (user.role === 'SUPER_ADMIN') {
        return true;
    }
    if (!user.allowedSystems) {
        return false;
    }
    // 檢查是否有 ALL 權限
    if (user.allowedSystems.includes('ALL')) {
        return true;
    }
    const normalizedSystemName = systemName.toUpperCase();
    return user.allowedSystems.includes(normalizedSystemName);
};
exports.hasSystemAccess = hasSystemAccess;
/**
 * 檢查用戶是否有系統存取權限並返回詳細資訊
 * @param systemName 系統名稱
 * @param user 用戶資料
 * @returns 包含權限狀態和原因的物件
 */
const checkSystemAccess = (systemName, user) => {
    if (!user) {
        return { hasAccess: false, reason: 'User not found' };
    }
    if (user.role === 'SUPER_ADMIN') {
        return { hasAccess: true, reason: 'SUPER_ADMIN role' };
    }
    if (!user.allowedSystems) {
        return { hasAccess: false, reason: 'No allowed systems configured' };
    }
    if (user.allowedSystems.includes('ALL')) {
        return { hasAccess: true, reason: 'ALL systems permission' };
    }
    const normalizedSystemName = systemName.toUpperCase();
    if (user.allowedSystems.includes(normalizedSystemName)) {
        return { hasAccess: true, reason: `Specific ${normalizedSystemName} permission` };
    }
    return { hasAccess: false, reason: `No permission for ${normalizedSystemName} system` };
};
exports.checkSystemAccess = checkSystemAccess;
/**
 * 檢查使用者是否有編輯權限
 * SUPER_ADMIN 和 ADMIN 可以編輯所有資料
 * USER 只能編輯自己的資料
 */
const canEdit = (userRole, ownerId, currentUserId) => {
    if (!userRole)
        return false;
    return (userRole === types_1.Role.SUPER_ADMIN ||
        userRole === types_1.Role.ADMIN ||
        (userRole === types_1.Role.USER && ownerId === currentUserId));
};
exports.canEdit = canEdit;
/**
 * 檢查使用者是否有刪除權限（僅角色檢查，不檢查所有權）
 * 只有 SUPER_ADMIN 和 ADMIN 可以刪除
 */
const canDelete = (userRole) => {
    if (!userRole)
        return false;
    return userRole === types_1.Role.SUPER_ADMIN || userRole === types_1.Role.ADMIN;
};
exports.canDelete = canDelete;
/**
 * 檢查使用者是否有刪除特定資料的權限（包含所有權檢查）
 * SUPER_ADMIN 和 ADMIN 可以刪除所有資料
 * USER 只能刪除自己建立的資料
 */
const canDeleteItem = (userRole, ownerId, currentUserId) => {
    if (!userRole)
        return false;
    return (userRole === types_1.Role.SUPER_ADMIN ||
        userRole === types_1.Role.ADMIN ||
        (userRole === types_1.Role.USER && ownerId === currentUserId));
};
exports.canDeleteItem = canDeleteItem;
/**
 * 檢查使用者是否有管理員權限
 * SUPER_ADMIN 和 ADMIN 都算管理員
 */
const isAdmin = (userRole) => {
    if (!userRole)
        return false;
    return userRole === types_1.Role.SUPER_ADMIN || userRole === types_1.Role.ADMIN;
};
exports.isAdmin = isAdmin;
